import defaultTheme from './defaultTheme';
const peaksTheme = Object.assign({}, defaultTheme);
export default peaksTheme;
